export const COCKPIT_MDF_CHART_TOP_GROUPS_COUNT = 15

export const SHOW_MANAGER_COCKPIT_MDF_ACTIVITY_DETAILS = false

/** Use backend MDFSales in both cockpits; disabling restores the single-partner calculation. */
export const USE_COCKPIT_MDF_SALES_FROM_DATA = true
